<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Label" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
export let label;
export let id;
export let isDisabled = false;
export let isRequired = false;
</script>

{#if label !== null}
    <label
        for = { id }
        class:s8-disabled = { isDisabled }
    >
        {#if label !== undefined}
            { $t(label) }
            {#if isRequired}
                <span class = 's8-required-asterisk'>*</span>
            {/if}
        {/if}
    </label>
{/if}

<style>
    label {
        display: block;
        font-size: 9px;
        line-height: 10px;
        opacity: 0;
    }

        label:not(:empty) {
            opacity: 1;
        }

        label:not(.s8-disabled) {
            transition: opacity 0.5s ease-in-out;
        }

        label.s8-disabled {
            color: rgba(39,39,17,0.24);
        }

        label .s8-required-asterisk {
            color: #8b0000;
            font-weight: bold;
            margin-left: 2px;
        }</style>